import React from 'react';
import ReviewCard from './ReviewCard';

/** `.avis-grid` — grille de cartes d'avis. */
const ReviewGrid = ({ reviews = [] }) => {
  if (!reviews.length) return null;
  return (
    <div className="avis-grid">
      {reviews.map((review, index) => (
        <ReviewCard
          key={`${review.sender || 'avis'}-${index}`}
          rating={review.rating}
          content={review.content}
          sender={review.sender}
        />
      ))}
    </div>
  );
};

export default ReviewGrid;
